import * as S from "./AlarmList.style";
import { AlarmItem } from "@/components/atoms/AlarmItem";

interface AlarmListProps {
  data?: any;
}

export const AlarmList = ({ data }: AlarmListProps) => {
  return (
    <S.AlarmList>
      {data.map((item: any, idx: number) => {
        return <AlarmItem data={item} key={idx} />;
      })}
    </S.AlarmList>
  );
};
